import { Component, HostBinding, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'eui-card-header-title',
    templateUrl: './eui-card-header-title.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EuiCardHeaderTitleComponent {

    @HostBinding('class') string = 'eui-card-header__title-container-title';

    constructor( ) {
    }
}
